import React, { useState, useRef, useEffect } from 'react';
import './ChatBot.css';

const formatMessageText = (text) => {
  // First, convert markdown links to HTML links
  const markdownLinkRegex = /\[(.*?)\]\((https?:\/\/[^\s]+)\)/g;
  let formattedText = text.replace(markdownLinkRegex, (match, title, url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="chat-link">${title}</a>`;
  });

  // Then, convert newlines to HTML breaks
  formattedText = formattedText.replace(/\n/g, '<br>');

  return formattedText;
};

const LogoIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M28.5925 20.7399C26.3613 21.6345 23.9528 22.1863 21.4338 22.3293C20.9994 22.3539 20.5616 22.3664 20.121 22.3664C19.6803 22.3664 19.2426 22.3539 18.8081 22.3293C16.2885 22.1863 13.8795 21.6343 11.6478 20.7393C6.96449 18.8611 3.06201 15.4723 0.556519 11.1832C4.46175 4.49787 11.7609 0 20.121 0C28.481 0 35.7802 4.49787 39.6854 11.1832C37.1796 15.4728 33.2766 18.8618 28.5925 20.7399Z" fill="white" />
    <path d="M11.6476 22.4803C11.1081 22.2639 10.5789 22.0275 10.061 21.772C8.37802 22.946 6.95525 24.4083 5.88391 26.0766C7.7049 28.9123 10.5412 31.1527 13.9451 32.3944C15.5671 32.9861 17.3179 33.351 19.1492 33.4456H21.0575C22.8884 33.3511 26.1063 35.1472 21.4336 39.68C24.8379 38.4383 32.5016 28.9126 34.3228 26.0766C33.2545 24.4131 31.8368 22.9544 30.1601 21.782C29.6482 22.034 29.1253 22.2672 28.5923 22.4809C26.3611 23.3756 23.9526 23.9273 21.4336 24.0703C20.9991 24.095 20.5614 24.1075 20.1207 24.1075C19.6801 24.1075 19.2424 24.095 18.8079 24.0703C16.2883 23.9273 13.8793 23.3753 11.6476 22.4803Z" fill="white" />
    <rect x="10.687" y="8.32251" width="18.9093" height="6.68764" rx="3.34382" fill="#162550" />
    <ellipse cx="25.3561" cy="11.6291" rx="1.23811" ry="1.22607" fill="#04FED1" />
    <ellipse cx="20.1033" cy="28.1252" rx="1.23811" ry="1.22607" fill="#162550" />
    <ellipse cx="15.1517" cy="11.6291" rx="1.23811" ry="1.22607" fill="#04FED1" />
    <ellipse cx="15.1517" cy="28.1252" rx="1.23811" ry="1.22607" fill="#162550" />
    <ellipse cx="25.0564" cy="28.1252" rx="1.23811" ry="1.22607" fill="#162550" />
  </svg>
);

const SmallLogoIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.4662 14.2587C17.9472 14.8737 16.3075 15.2531 14.5925 15.3514C14.2967 15.3683 13.9987 15.3769 13.6987 15.3769C13.3987 15.3769 13.1007 15.3683 12.8049 15.3514C11.0895 15.2531 9.4494 14.8736 7.93004 14.2583C4.74155 12.967 2.08468 10.6372 0.378906 7.68846C3.03765 3.09229 8.00704 0 13.6987 0C19.3903 0 24.3597 3.09229 27.0184 7.68846C25.3125 10.6376 22.6552 12.9675 19.4662 14.2587Z" fill="white" />
    <path d="M7.92982 15.4552C7.56249 15.3065 7.20222 15.1439 6.84965 14.9683C5.70382 15.7754 4.73518 16.7807 4.0058 17.9277C5.24556 19.8772 7.17657 21.4175 9.49397 22.2712C10.5982 22.678 11.7903 22.9289 13.037 22.9939H14.3362C15.5827 22.9289 17.7735 24.1638 14.5922 27.28C16.91 26.4264 22.1275 19.8774 23.3674 17.9277C22.6401 16.784 21.6749 15.7812 20.5334 14.9752C20.1849 15.1484 19.8289 15.3087 19.466 15.4557C17.947 16.0707 16.3072 16.4501 14.5922 16.5484C14.2965 16.5653 13.9985 16.5739 13.6984 16.5739C13.3984 16.5739 13.1004 16.5653 12.8047 16.5484C11.0893 16.4501 9.44918 16.0705 7.92982 15.4552Z" fill="white" />
    <rect x="7.27582" y="5.72168" width="12.8737" height="4.59775" rx="2.29888" fill="#162550" />
    <ellipse cx="17.2628" cy="7.99502" rx="0.842922" ry="0.842921" fill="#04FED1" />
    <ellipse cx="13.6866" cy="19.3361" rx="0.842922" ry="0.842921" fill="#162550" />
    <ellipse cx="10.3155" cy="7.99502" rx="0.842922" ry="0.842921" fill="#04FED1" />
    <ellipse cx="10.3155" cy="19.3361" rx="0.842922" ry="0.842921" fill="#162550" />
    <ellipse cx="17.0587" cy="19.3361" rx="0.842922" ry="0.842921" fill="#162550" />
  </svg>
);

const FullscreenIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 7V3C2 2.44772 2.44772 2 3 2H7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 2H17C17.5523 2 18 2.44772 18 3V7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 13V17C18 17.5523 17.5523 18 17 18H13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 18H3C2.44772 18 2 17.5523 2 17V13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.86158 3.4969L14.9378 7.03503C18.1122 8.62223 18.1122 11.218 14.9378 12.8052L7.86158 16.3433C3.09998 18.7241 1.15731 16.7732 3.53811 12.0198L4.25731 10.5897C4.43918 10.226 4.43918 9.6225 4.25731 9.25877L3.53811 7.82037C1.15731 3.06703 3.10825 1.1161 7.86158 3.4969Z" stroke="#4361EE" strokeWidth="1.24" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.49707 9.91992H8.96107" stroke="#4361EE" strokeWidth="1.24" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);



const CheckSingleIcon = () => (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.60432 0.209855C7.83105 -0.0466531 8.22276 -0.0714645 8.47932 0.155167C8.73583 0.381899 8.75967 0.773606 8.53303 1.03017L3.56428 6.65224C3.44654 6.78529 3.27712 6.8613 3.09944 6.86122C2.92173 6.86108 2.75217 6.78452 2.63459 6.65126L0.155103 3.84071C-0.0713839 3.58396 -0.0469443 3.19224 0.20979 2.96571C0.466526 2.73924 0.858248 2.76373 1.08479 3.0204L3.10042 5.30458L7.60432 0.209855Z" fill="#999999" />
  </svg>
);

const CheckDoubleIcon = () => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.47932 0.155167C8.22276 -0.0714645 7.83105 -0.0466531 7.60432 0.209855L4.32777 3.91622C4.29984 3.94256 4.27488 3.97093 4.25291 4.00091L3.10042 5.30458L1.08479 3.0204C0.858248 2.76373 0.466526 2.73924 0.20979 2.96571C-0.0469443 3.19224 -0.0713839 3.58396 0.155103 3.84071L2.63459 6.65126C2.75217 6.78452 2.92173 6.86108 3.09944 6.86122C3.27712 6.8613 3.44654 6.78529 3.56428 6.65224L4.75419 5.30587L5.94175 6.65125C6.05938 6.78457 6.2288 6.86113 6.40659 6.86121C6.58428 6.86122 6.75375 6.78537 6.87144 6.65223L11.8402 1.03016C12.0666 0.773591 12.0419 0.381815 11.7855 0.155156C11.5289 -0.0712196 11.1371 -0.046574 10.9105 0.209844L6.40659 5.30359L5.58199 4.36923L8.53303 1.03017C8.75967 0.773606 8.73583 0.381899 8.47932 0.155167Z" fill="#7B2CBF" />
  </svg>
);

const isValidPhone = (phone) => {
  const phoneRegex = /^\+?[0-9\s-]{7,15}$/;
  return phoneRegex.test(phone);
};

const isValidEmail = (email) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(email);
};

const ChatBot = () => {
  const [chat, setChat] = useState(() => {
    const sessionId = localStorage.getItem("chat_session");
    const userName = localStorage.getItem("user_name");
    let initialMessageText = 'Welcome to Iqra Technology, how can I help you?';

    if (sessionId && userName) {
      initialMessageText = `Welcome back to Iqra Technology, ${userName}. How can I help you today?`;
    }

    return [
      {
        type: 'system',
        text: initialMessageText,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      },
    ];
  });
  const [inputValue, setInputValue] = useState('');
  const chatTranscriptRef = useRef(null);
  const [conversationState, setConversationState] = useState('CHATTING');
  const [pendingMessage, setPendingMessage] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (chatTranscriptRef.current) {
      chatTranscriptRef.current.scrollTop = chatTranscriptRef.current.scrollHeight;
    }
  }, [chat, isTyping]); // Added isTyping to dependency array

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const sendToN8N = async (message) => {
    const sessionId = localStorage.getItem("chat_session");
    const name = localStorage.getItem("user_name");
    const phone = localStorage.getItem("user_phone");
    const email = localStorage.getItem("user_email");

    setIsTyping(true); // Set typing status to true

    try {
      const response = await fetch("https://n8n.iqratechnology.com/webhook/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          sessionId,
          name,
          phone,
          email,
          chatInput: message
        })
      });
      console.log("response:" + response)
      const data = await response.text();

      setChat(prev => [...prev, { type: "system", text: data, time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);

    } catch (error) {
      console.error("Error:", error);
      setChat(prev => [...prev, { type: "system", text: "⚠️ Server unreachable!", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
    } finally {
      setIsTyping(false); // Set typing status to false regardless of success or failure
    }
  };

  const handleSendMessage = async () => {
    if (!inputValue.trim()) return;
    const currentMessage = inputValue;
    setInputValue("");

    setChat(prev => [...prev, { type: "user", text: currentMessage, time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);

    if (conversationState === 'ONBOARDING_ASK_NAME') {
      localStorage.setItem("user_name", currentMessage);
      setConversationState('ONBOARDING_ASK_PHONE');
      setChat(prev => [...prev, { type: "system", text: "Great! What's your phone number?", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      return;
    }
    if (conversationState === 'ONBOARDING_ASK_PHONE') {
      if (isValidPhone(currentMessage)) {
        localStorage.setItem("user_phone", currentMessage);
        setConversationState('ONBOARDING_ASK_EMAIL');
        setChat(prev => [...prev, { type: "system", text: "Got it. And your email?", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      } else {
        setChat(prev => [...prev, { type: "system", text: "Please enter a valid phone number.", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      }
      return;
    }
    if (conversationState === 'ONBOARDING_ASK_EMAIL') {
      if (isValidEmail(currentMessage)) {
        localStorage.setItem("user_email", currentMessage);
        setConversationState('CHATTING');
        setChat(prev => [...prev, { type: "system", text: "Thanks! I'm now answering your question.", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
        if (pendingMessage) {
          await sendToN8N(pendingMessage);
          setPendingMessage(null);
        }
      } else {
        setChat(prev => [...prev, { type: "system", text: "Please enter a valid email address.", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      }
      return;
    }

    const sessionId = localStorage.getItem("chat_session");

    if (sessionId) {
      await sendToN8N(currentMessage);
    } else {
      setPendingMessage(currentMessage);
      const newSessionId = crypto.randomUUID();
      localStorage.setItem("chat_session", newSessionId);
      setConversationState('ONBOARDING_ASK_NAME');
      setChat(prev => [...prev, { type: "system", text: "Welcome! What is your name?", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const toggleFullscreen = () => {
    const newFullscreenState = !isFullscreen;
    setIsFullscreen(newFullscreenState);

    // Check if running inside an iframe
    if (window.self !== window.top) {
      // Send message to parent window to toggle fullscreen
      window.parent.postMessage({
        type: 'CHATBOT_FULLSCREEN_TOGGLE',
        isFullscreen: newFullscreenState
      }, '*');
    }
  };



  return (
    <div className={`chat-preview-pane ${isFullscreen ? 'fullscreen' : ''}`}>
      <div className="chat-container">
        <header className="chat-header-wrapper">
          <div className="chat-header"></div>
          <div className="header-content">
            <div className="header-left">
              <div className="logo-large">
                <LogoIcon />
              </div>
              <div className="brand-info">
                <div className="brand-name">Iqra Bot</div>
                <div className="status-online">
                  <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3.30667" cy="3.30667" r="3.30667" fill="#43EE7D" />
                  </svg>
                  <span>Online</span>
                </div>
              </div>
            </div>
            <div className="header-actions" onClick={toggleFullscreen} style={{ cursor: 'pointer' }}>
              <FullscreenIcon />
            </div>
          </div>
        </header>

        <main className="chat-transcript" ref={chatTranscriptRef}>
          {chat.map((message, index) => (
            <div key={index} className={`${message.type}-message`}>
              <div className={`message-bubble ${message.type}-bubble`}>
                <div className="message-content">
                  <div className="message-text" dangerouslySetInnerHTML={{ __html: formatMessageText(message.text) }}></div>
                </div>
                {message.type === 'system' && (
                  <svg className="bubble-tail-left" width="33" height="9" viewBox="0 0 33 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 -14.5332C0 -15.9029 1.11033 -17.0132 2.48 -17.0132H29.8037C32.1826 -17.0132 33.1968 -13.9885 31.2988 -12.5545L3.97503 8.09013C2.34125 9.32454 0 8.1591 0 6.11142V-14.5332Z" fill="#3C096C" />
                  </svg>
                )}
                {message.type === 'user' && (
                  <svg className="bubble-tail-right" width="33" height="26" viewBox="0 0 33 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32.2886 2.48C32.2886 1.11033 31.1782 0 29.8086 0H2.48484C0.105979 0 -0.908207 3.02466 0.989807 4.45871L28.3135 25.1033C29.9473 26.3377 32.2886 25.1723 32.2886 23.1246V2.48Z" fill="#DEE2E6" />
                  </svg>
                )}
                {message.type === 'system' && (
                  <div className="message-timestamp">
                    <span>{message.time}</span>
                  </div>
                )}
              </div>
              {/* Timestamp outside bubble for user messages */}
              {message.type === 'user' && (
                <div className="message-timestamp user-timestamp-outside">
                  <span>{message.time}</span>
                </div>
              )}

              {message.type === 'user' && message.status && (
                <div className={`message-check ${message.status === 'read' ? 'checked' : ''}`}>
                  {message.status === 'read' ? <CheckDoubleIcon /> : <CheckSingleIcon />}
                </div>
              )}
              {message.type === 'system' && (
                <div className="avatar-small">
                  <div className="avatar-background"></div>
                  <SmallLogoIcon />
                </div>
              )}
            </div>
          ))}
          {isTyping && (
            <div className="system-message">
              <div className="message-bubble system-bubble">
                <div className="message-content">
                  <div className="message-text">Typing...</div>
                </div>
              </div>
              <div className="avatar-small">
                <div className="avatar-background"></div>
                <SmallLogoIcon />
              </div>
            </div>
          )}
        </main>

        <footer className="chat-footer">
          <div className="tag-container">
            <div className="tag" onClick={() => window.open('https://iqratechnology.com/contact-us/', '_blank')} style={{ cursor: 'pointer' }}>
              🤔 Contact Sales Team
            </div>
            {/* <div className="tag" onClick={() => window.open('https://iqratechnology.com/services/', '_blank')} style={{ cursor: 'pointer' }}>
              Services
            </div>
            <div className="tag" onClick={() => window.open('https://iqratechnology.com/products/', '_blank')} style={{ cursor: 'pointer' }}>
              Products
            </div> */}
          </div>
          <div className="input-area">
            <input
              type="text"
              className="input-placeholder"
              placeholder="Type your message here..."
              value={inputValue}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
            <button onClick={handleSendMessage}>
              <SendIcon />
            </button>
          </div>
        </footer>

        <div className="header-shadow"></div>
      </div>
    </div>
  );
};

export default ChatBot;
